import DOMPurify from 'dompurify';

// Autorise le rendu riche (tables, styles inline, images cid:/data: des emails)
// tout en neutralisant les vecteurs XSS : <script>, gestionnaires on*, URLs javascript:.
const ALLOWED_URI_REGEXP = /^(?:(?:https?|mailto|tel|cid|data):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i;

export const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html || '', {
    ADD_ATTR: ['target'],
    ALLOWED_URI_REGEXP,
  });
